// Web no-op — interactive cards use Tamagui's `pressStyle` scale on web.
// Native version (`usePressScale.native.ts`) drives the press-scale via
// Reanimated.

const NOOP = () => {};

export const usePressScale = (
  _disabled?: boolean,
): {
  animatedStyle: undefined;
  onPressIn: () => void;
  onPressOut: () => void;
} => ({
  animatedStyle: undefined,
  onPressIn: NOOP,
  onPressOut: NOOP,
});
